import { Component, computed, input } from "@angular/core";
import { ChipsComponent } from "../../../../shared/modules/chips/chips.component";
import { OfEtat } from "../../enums/etat-of.enum";
import { OfHelperService } from "../../services/of-helper.service";
import { EnumsUtils } from "../../../../shared/utils/enums.utils";

@Component({
  selector: "vl-etat-of",
  standalone: true,
  imports: [ChipsComponent],
  templateUrl: "./etat-of.component.html",
  styleUrl: "./etat-of.component.scss",
})
export class EtatOfComponent {
  etat = input<OfEtat>();
  iconLeft = computed(() => {
    return OfHelperService.getIconByEtat(this.etat());
  });
  color = computed(() => {
    return OfHelperService.getColorByEtat(this.etat());
  });

  state = computed(() => {
    return OfHelperService.getStateByEtat(this.etat());
  });

  etatLibelle = computed(() => {
    return EnumsUtils.libelleFromEnum(OfEtat, 'enums.of_etat', this.etat());
  });
}
